/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getCategoryPathsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { CategoryPathResult } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

/**
 * CustomGetCategoryPaths Input Action
 */
export class CustomGetCategoryPathsInput implements Msdyn365.IActionInput {
    constructor() {}
    public getCacheKey = () => `CustomGetCategoryPathsCacheKey`;
    public getCacheObjectType = () => 'CustomGetCategoryPathsObjectType';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

export interface ICustomGetCategoryPathsData {
    text: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new CustomGetCategoryPathsInput();
};

async function action(input: CustomGetCategoryPathsInput, ctx: Msdyn365.IActionContext): Promise<CategoryPathResult[] | null> {
    const apiSettings = ctx.requestContext.apiSettings;

    if (ctx.requestContext.query && ctx) {
        const tempIds = ctx.requestContext.query.productIds.split(',');
        const productIds: number[] = [];
        tempIds.forEach(id => {
            id && productIds.push(Number(id))
        })

        let productLookups = productIds.map(pId => {
            return {
                ProductId: pId
            } 
        });

        const categoryPathResults = await getCategoryPathsAsync({ callerContext: ctx }, apiSettings.channelId, apiSettings.catalogId, productLookups);
        return categoryPathResults;
    }

    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<CategoryPathResult[] | null>>action,
    id: 'CustomGetCategoryPaths',
    input: createInput
});
